module.exports = __webpack_public_path__ + "img/chunjie.c69fb445.jpg";